export var ComponentFeature;
(function (ComponentFeature) {
    ComponentFeature["MAIN"] = "main";
    ComponentFeature["FILTERING"] = "filtering";
    ComponentFeature["PROPERTY_FILTERING"] = "propertyFiltering";
    ComponentFeature["SORTING"] = "sorting";
    ComponentFeature["PAGINATION"] = "pagination";
    ComponentFeature["SELECTION"] = "selection";
})(ComponentFeature || (ComponentFeature = {}));
export var FilteringOperation;
(function (FilteringOperation) {
    FilteringOperation["AND"] = "and";
    FilteringOperation["OR"] = "or";
})(FilteringOperation || (FilteringOperation = {}));
export var PropertyFilteringOptionGroup;
(function (PropertyFilteringOptionGroup) {
    PropertyFilteringOptionGroup["PROPERTY"] = "property";
    PropertyFilteringOptionGroup["VALUE"] = "value";
})(PropertyFilteringOptionGroup || (PropertyFilteringOptionGroup = {}));
//# sourceMappingURL=internal.js.map